import { format } from 'date-fns';
import { ru, enUS } from 'date-fns/locale';
import type {
  Language,
  OperationDto,
  OperationStatusIcon,
  OperationTypeIcon,
} from '@/shared/types';
import { OperationsHistoryItem } from '@/entities/operation';
import { useGroupOperationsByDate } from '@/shared/lib';

type Props = {
  operations: OperationDto[];
  language: Language;
  operationTypeIcons: OperationTypeIcon[];
  operationStatusIcons: OperationStatusIcon[];
  onOperationItemClick?: (operation: OperationDto) => void;
  selectedOperationId?: string;
};

export const HistoryOperationsList = ({
  operations,
  language,
  operationTypeIcons,
  operationStatusIcons,
  onOperationItemClick,
  selectedOperationId,
}: Props) => {
  const locale = language === 'ru' ? ru : enUS;

  const { groupedOperations } = useGroupOperationsByDate(operations);

  return (
    <div className="flex flex-col gap-[2.4rem]">
      {Object.entries(groupedOperations).map(([monthYear, monthOperations]) => {
        const title = format(new Date(`${monthYear}-01`), 'LLLL yyyy', {
          locale,
        });

        return (
          <section className="flex flex-col gap-[0.8rem]" key={monthYear}>
            <h2 className="px-[1.6rem] headline5 text-primary capitalize">
              {title}
            </h2>

            <div className="flex flex-col">
              {monthOperations.map(operation => (
                <OperationsHistoryItem
                  key={operation.operaionid}
                  variant="compact"
                  isSelected={operation.operaionid === selectedOperationId}
                  operation={operation}
                  operationStatusIcons={operationStatusIcons}
                  operationTypeIcons={operationTypeIcons}
                  onOperationItemClick={onOperationItemClick}
                />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
};
